import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Services are typically provided at root level, so this is a simple provider module
import { DataAgentSSEService } from './data-agent-sse.service';
import { InsightsSuggestionsService } from './insights-suggestions.service';
import { DataBricksAiGenieChatService } from './databricks-genie-ai-chat.service';

@NgModule({
  imports: [CommonModule],
  providers: [DataAgentSSEService, InsightsSuggestionsService, DataBricksAiGenieChatService],
})
export class ServicesAgentsModule {}
